export default "__VITE_ASSET__Y69ccOuu__"